const US_VORTEX_DLS6_ALLOW_LIST_REGEX = [
  /^\/dashboard/g,
  /^\/overview/g,
  /^\/rewards/g,
  /^\/demo/g,
  /^\/activity/g,
  /^\/statements/g,
  /^\/account-management/g,
  /^\/payments/g,
  /^\/offers/g,
  /^\/search/g,
  /^\/direct-debits/g,
  /^\/banking/g,
  /^\/en-us\/banking/g,
];

const CA_VORTEX_DLS6_ALLOW_LIST_REGEX = [
  /^\/demo/g,
  /^\/activity/g,
  /^\/statements/g,
];

const VORTEX_DLS6_ALLOW_LIST_REGEX = {
  'en-US': US_VORTEX_DLS6_ALLOW_LIST_REGEX,
  'en-CA': CA_VORTEX_DLS6_ALLOW_LIST_REGEX,
  'fr-CA': CA_VORTEX_DLS6_ALLOW_LIST_REGEX,
};

export const DLS6_VORTEX_LOCALE = [
  'en-US',
  'en-CA',
  'fr-CA',
];

/** Below are Vortex DLS6. */
const isVortexQueryParamPresent = (location) => {
  const { query: { vortex } = {} } = location;
  if (!vortex) return false;
  if (typeof vortex === 'string') {
    return vortex === 'true';
  }
  return vortex.every((v) => v === 'true');
};

export const isInAllowList = ({ location = {}, locale }) => {
  const { [locale]: allowList = [] } = VORTEX_DLS6_ALLOW_LIST_REGEX;
  const { pathname = '' } = location;
  return allowList.some((regExp) => pathname.match(regExp) !== null);
};

export const isVortexEnabled = ({ location = {}, vortexEnabled }) => {
  if (!vortexEnabled) {
    return isVortexQueryParamPresent(location);
  }
  return vortexEnabled;
};

export const isVortexPage = ({ location = {}, vortexEnabled, locale }) => {
  if (!vortexEnabled) {
    return false;
  }
  return isInAllowList({ location, locale });
};

export const generateBodyAttributes = ({
  location,
  locale,
  styleSheetHref,
  isDls7Eligible,
  isDls7Enabled,
  isVortexEnabled: isVortex,
}) => {
  let styleHref = styleSheetHref.dls6;
  let bodyAttributes = 'dls6-intl dls-gray-02-bg';
  let colorTheme = 'light';

  if (DLS6_VORTEX_LOCALE.includes(locale) && isVortex) {
    styleHref = styleSheetHref.vortexDls6;
    if (isInAllowList({ location, locale })) {
      bodyAttributes = 'body-v vortex dls-gray-02-bg';
    } else {
      bodyAttributes = 'body-v dls-gray-02-bg';
    }
  }

  if (isDls7Eligible === 'eligible' || isDls7Eligible === 'dev' || isDls7Eligible === 'dev-dark') {
    colorTheme = isDls7Eligible === 'dev-dark' ? 'dark' : 'light';
    if (isDls7Enabled) {
      styleHref = styleSheetHref.dls7;
      bodyAttributes = 'color-surface-bg color-text-regular';
      if (DLS6_VORTEX_LOCALE.includes(locale)) {
        bodyAttributes += ' dls7-us';
      }
    } else if (DLS6_VORTEX_LOCALE.includes(locale) && isVortex) {
      styleHref = styleSheetHref.vortexDls6;
      if (isInAllowList({ location, locale })) {
        bodyAttributes = 'body-v vortex dls-gray-02-bg dls7-eligible';
      } else {
        bodyAttributes = 'body-v dls-gray-02-bg dls7-eligible';
      }
    } else {
      bodyAttributes = 'dls6-intl dls-gray-02-bg dls7-eligible';
    }
  }
  return { bodyAttributes, styleHref, colorTheme };
};
